import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import Header from '@components/Details/Header'
import PropTypes from 'prop-types'
import { StatusLabel } from '@components/StatusLabel'
import Badge from '@components/Details/Badge'
import { formatNumber } from '@atheneum/api/dist/lib'

class ContractHeader extends Component {
  static propTypes = {
    contractStore: PropTypes.object,
    staticData: PropTypes.object
  }

  render () {
    const { contract } = this.props.contractStore
    const { names, CONST } = this.props.staticData
    const {
      parentAccount,
      currencyId,
      contractTypeId,
      contractBalance,
      consumption,
      unlimited
    } = contract

    const currency =
      contractTypeId === CONST.CONTRACT_TYPES.PAYG
        ? names.currencies[currencyId]
        : 'credits'

    return (
      <Header>
        <div className='info info--noLeft'>
          <div>
            <div className='name-status-wrapper'>
              <h1 className='contract-heading'>
                {contract.contractReference}
                <StatusLabel
                  statusId={contract.contractStatusId}
                  statusesType='contractStatuses'
                />
              </h1>
            </div>
            <span className='code-label'>
              {parentAccount.parentAccountName}
            </span>
          </div>
        </div>
        <Badge
          label='Balance'
          value={`${
            unlimited ? 'N/A' : `${formatNumber(contractBalance)} ${currency}`
          }`}
        />
        <Badge
          label='Consumed'
          value={`${formatNumber(consumption)} ${currency}`}
        />
      </Header>
    )
  }
}

export default inject('staticData')(observer(ContractHeader))
